export enum AddOnsApiTagTypes {
  AddOn = 'AddOn',
  AddOnSecret = 'AddOnSecret',
  AddOnVersions = 'AddOnVersions',
  SellerAddonIntegration = 'SellerAddonIntegration',
}
